module.exports = __webpack_public_path__ + "img/tree-08-c-leaves.de430b04.png";